import {MainStore} from './main/MainStore'
import {HomeStore} from './home/HomeStore'
import {ListStore} from './list/ListStore'
import {AddListStore} from './addList/AddListStore'
import {OrderStore} from './order/OrderStore'
import {ProjectStore} from './project/ProjectStore'
import {CollectStore} from './collect/CollectStore'
import {SchemeStore} from './scheme/SchemeStore'
import {RouterStore} from 'mobx-react-router';
import {InitStore} from './init/InitStore';
import {RewardStore} from './reward/RewardStore';
import {PriceStore} from  './price/PriceStore';
import {ThemeListStore} from  './home/ThemeListStore';
import {OldApplyStore} from  './oldApply/index';
import {ModeListStore} from './modeList/index';
import {AppDetailStore} from './modeList/appDetailStore';
import {CaseListStore} from './home/CaseListStore';
import {EcodeStore} from './ecode/EcodeStore';
import {EcodeWfStore} from './ecode/EcodeWfStore';
import WorkflowStore from './workflow/WorkflowStore';
const routing = new RouterStore();

const mainStore = new MainStore(routing);
const homeStore = new HomeStore(routing);
const listStore = new ListStore(routing,homeStore);
const addListStore = new AddListStore(routing);
const collectStore = new CollectStore(routing);
const projectStore = new ProjectStore(routing);
const schemeStore = new SchemeStore(routing);
const orderStore = new OrderStore(routing);
const initStore = new InitStore(routing);
const rewardStore = new RewardStore(routing);
const priceStore = new PriceStore(routing);
const themeListStore = new ThemeListStore(routing);
const oldApplyStore = new OldApplyStore(routing);
const modeListStore = new ModeListStore(routing);
const appDetailStore = new AppDetailStore(routing);
const caseListStore = new CaseListStore(routing)
const ecodeStore = new EcodeStore(routing);
const ecodeWfStore = new EcodeWfStore(routing);
const workflowStore = new WorkflowStore(routing);

module.exports = {
  routing,
  mainStore,
  homeStore,
  listStore,
  addListStore,
  collectStore,
  projectStore,
  schemeStore,
  orderStore,
  initStore,
  rewardStore,
  priceStore,
  themeListStore,
  oldApplyStore,
  modeListStore,
  appDetailStore,
  caseListStore,
  ecodeStore,
  ecodeWfStore,
  workflowStore,
};


// WEBPACK FOOTER //
// ./src/stores/index.js